module.exports = __webpack_public_path__ + "img/check2.f73a006d.svg";